import React from "react";
import { Paragraph, useTheme } from "@tvg/design-system";
import { RacePool } from "@tvg/ts-types/Race";
import { formatCurrencyShortened } from "@tvg/formatter/currency";
import { THead, Th, Tr } from "../styled-components";
import { MAX_AMOUNT } from "../constants";
import { getOrderedRacePools } from "../handlers";
import TooltipExceededAmounts from "./TooltipExceededAmounts";

interface Props {
  racePools: RacePool[];
  wagerTypeLimit: number;
}

const ExoticNPicksPools = ({ racePools, wagerTypeLimit }: Props) => {
  const { colors } = useTheme();

  const hasExoticNPicksPools = racePools.some(
    (pool) => pool.wagerType.id > wagerTypeLimit
  );

  if (!hasExoticNPicksPools) {
    return null;
  }

  const orderedRacePools = getOrderedRacePools(racePools, wagerTypeLimit, true);
  const tableRows = orderedRacePools.reduce((acc, racePool, index) => {
    if (index % 4 === 0) {
      return [...acc, [racePool]];
    }
    acc[acc.length - 1] = [...acc[acc.length - 1], racePool];
    return acc;
  }, [] as RacePool[][]);

  return (
    <THead data-qa-label="pools-exotic-n-picks-table-header">
      {tableRows.map((pool: RacePool[]) => (
        <Tr
          key={`pools-row-${pool
            .map((p: RacePool) => p.wagerType.code)
            .join("-")}`}
          backgroundColor={colors.blue_accent["000"]}
        >
          {pool.map((p) => (
            <Th
              key={`pools-column-${p.wagerType.code}`}
              data-qa-label={`pools-column-${p.wagerType.code}`}
              textCenter
              padding="12px 6px"
            >
              <Paragraph
                fontSize="s"
                fontWeight={600}
                color="grey.900"
                qaLabel="pools-wagerType-name"
              >
                {p.wagerType.name.length > 10
                  ? p.wagerType.code
                  : p.wagerType.name}
              </Paragraph>
              <br />
              <Paragraph
                fontSize="xs"
                fontWeight={400}
                color="grey.800"
                qaLabel="pools-amount"
              >
                {p.amount > MAX_AMOUNT ? (
                  <TooltipExceededAmounts amount={p.amount} />
                ) : (
                  formatCurrencyShortened(p.amount)
                )}
              </Paragraph>
            </Th>
          ))}
        </Tr>
      ))}
    </THead>
  );
};

export default ExoticNPicksPools;
